import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import cargoOfficerAddUserPermissionDefinition from "./cargo-officer-add-user-permission";

const useCargoOfficerAddUserPermissions = () => {
  return useUserPermissions(cargoOfficerAddUserPermissionDefinition);
};

export default useCargoOfficerAddUserPermissions;
